import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { DialogActions } from "@mui/material";
// import { __APP_ROOT } from '..';
import Draggable from 'react-draggable';
import Fade from '@mui/material/Fade';
import { useLayoutEffect, useRef, useState } from 'react';
import {
  StyledDraggableDialogContent as DialogContent,
  StyledDraggableDialogClose as CloseButton,
  StyledDraggableDialogPaper as DialogWrapper,
  StyledDraggableDialogTitle as DialogTitle,
  StyledDraggableDialogIconWrapper as IconWrapper
} from './DraggableDialog.styles';

function DraggableDialog(props) {
  
  const {
    title,
    description,
    IconComponent = DragIndicatorIcon,
    isOpen,
    close,
    children,
    ...restProps
  } = props;

  const [position, setPosition] = useState({ x: 20, y: 20 });
  const paperRef = useRef();
  const handleStop = (e, data) => setPosition({ x: data.x, y: data.y });
  const id = useRef(`handle_draggable_${title.replace(' ', '_')}`);

  useLayoutEffect(() => {
    if (isOpen) {
      setPosition({
        x: 20,
        y: (
            paperRef.current.parentElement.clientHeight 
          - paperRef.current.getBoundingClientRect().height 
          - 20
        )
      });
    }
  }, [isOpen]);

  return (
    <Draggable
      bounds="parent"
      handle={`#${id.current}`}
      position={position}
      onStop={handleStop}
    >
      <Fade in={isOpen}>
        <DialogWrapper ref={paperRef} {...restProps}>
          <DialogTitle id={id.current}>
            <IconWrapper>
              <IconComponent />
            </IconWrapper>
            {title} 
            <CloseButton size='small' onClick={close}>
              Chiudi
            </CloseButton>
          </DialogTitle>
          <DialogContent sx={{ pb: 0, }}>
            {description}
          </DialogContent>
          <DialogContent>
            {children}
          </DialogContent>
          <DialogActions></DialogActions>
        </DialogWrapper>
      </Fade>
    </Draggable>
  )
};

export default DraggableDialog;